import styled from 'styled-components'
import { frostedGlass } from 'Utils/styles/colors'

export const AdminPageContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  display: grid;
  grid-template-rows: 150px 1fr 120px;
  background-color: ${frostedGlass};
  overflow-y: auto;
`
